import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {axiosBase} from "../api/fetchWrapper";
import {displayMessage, patternListChoices, validateFormInput} from "../helper/tools";


export default function FormForgottenPassword({ legend, setShowModal }) {
    const navigate = useNavigate();
    const [ email, setEmail ] = useState();
    const FORGOT_PASSWORD_URL = '/api-v1/user/password/recovery';
    const [message, setMessage] = useState({text: "", type: ""})

    const handleChange = (e) => {
        setEmail(e.target.value)
        validateFormInput(e)
    }

    const handleSubmit = async () => {
        const response = await axiosBase.post(
            FORGOT_PASSWORD_URL,
            {email},
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(response => {
            if (!response?.data?.error) {
                setMessage({text: `${response?.data?.message}`, type: "success"})
            } else {
                setMessage({text: `${response?.data?.error}`, type: "error"})
            }
        })
    }

    useEffect(() => {
        if (message) {
            displayMessage(message)
        }
    }, [ message ])

    return (
        <form method="POST" noValidate>
            <fieldset className="mini-form">
                {(legend !== "no-legend") && <legend>{legend}</legend>}
                <div className="form-input">
                    <p>(L'adresse mail que vous avez renseignée pour créer votre compte)</p>
                    <label htmlFor="email">Adresse e-mail</label>
                    <input pattern={patternListChoices?.email} type="email" name="email" id="email" required onChange={handleChange} />
                </div>
                { message?.text !== "" &&
                    <div className="message"></div>
                }
            </fieldset>
                {message?.type === "success" &&
                    <div className="buttons-container">
                        <button type="button" className="blue-button" onClick={() => setShowModal(false)}>
                            <i className="fa fa-arrow-left"></i>
                            <span>Retour</span>
                        </button>
                    </div>
                }
                { message?.type !== "success" &&
                    <div className="buttons-container">
                        <button type="button" className="red-button" onClick={() => setShowModal(false)}>
                            <i className="fa fa-xmark"></i>
                            <span>Annuler</span>
                        </button>
                        <button type="button" className="green-button" onClick={handleSubmit}>
                            <i className="fa fa-check"></i>
                            <span>Enregistrer</span>
                        </button>
                    </div>
                }
        </form>
    )
}